import { Path, Svg } from 'react-native-svg';

export const SvgMinus = () => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={11}
      height={2}
      fill="red"
      viewBox="0 0 11 2"
    >
      <Path fill="#BBB" d="M10.746 2h-10V0h10v2Z" />
    </Svg>
  );
};
